import { useParams } from 'react-router-dom';

import { Dashboard, AdsPdfManager } from '@/components';

export const AdsPdfManagerPage = () => {
  const { id } = useParams();

  return <Dashboard openLogIn>{id && <AdsPdfManager id={id} />}</Dashboard>;
};
